import { render } from "./CertificationComponent.vue?vue&type=template&id=94c83510"
import script from "./CertificationComponent.vue?vue&type=script&lang=js"
export * from "./CertificationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__